import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Edit03 = function Edit03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 20h9M3 20h1.6746c.4892 0 .7338 0 .964-.0553.204-.049.399-.1298.578-.2394.2019-.1237.3748-.2967.7207-.6426L19.5001 6.5c.8284-.8284.8284-2.1716 0-3s-2.1716-.8284-3 0L3.9373 16.0627c-.346.3459-.5189.5189-.6425.7207a2 2 0 0 0-.2395.5781C3 17.5917 3 17.8363 3 18.3255z"
    })
  }));
};
export default Edit03;